import { NavLink, Outlet, useLocation } from "react-router";
import { hub, type Me } from "@/lib/hub";
import { useUiLang } from "@/lib/lang";

// The hub's frame around the home, Users and Activity screens: a Midnight top bar with the hub's name, the owners'
// screens, who is signed in, Sign out, and English | العربية. The websites list is in both languages; the owners'
// Users and Activity screens stay in English (left to right). A website's dashboard has its own frame
// (sites/<kind>/).

const tab = ({ isActive }: { isActive: boolean }) =>
  `flex min-h-11 items-center rounded-lg px-3 text-sm font-bold whitespace-nowrap transition-colors ${isActive ? "bg-offwhite text-midnight" : "text-offwhite/80 hover:bg-offwhite/10 hover:text-offwhite"}`;

export function Shell({ me }: { me: Me }) {
  const { L, lang, dir, setLang } = useUiLang();
  const { pathname } = useLocation();
  const signOut = async () => {
    await hub.logout().catch(() => {});
    window.location.assign("/login");
  };
  return (
    <div className="min-h-svh" dir={dir} lang={lang}>
      <header className="bg-midnight text-offwhite">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3 sm:px-6">
          <NavLink to="/" className="me-auto inline-flex min-h-11 items-center font-bold tracking-tight">
            <span className="font-mono text-[0.7rem] tracking-[0.25em] text-amber uppercase">{L("Dashboards", "لوحات التحكم")}</span>
          </NavLink>
          <nav aria-label={L("Hub", "اللوحة")} className="flex gap-1">
            <NavLink to="/" end className={tab}>
              {L("Websites", "المواقع")}
            </NavLink>
            {me.role === "owner" && (
              <>
                <NavLink to="/users" className={tab}>
                  Users
                </NavLink>
                <NavLink to="/activity" className={tab}>
                  Activity
                </NavLink>
              </>
            )}
          </nav>
          <div className="flex items-center gap-2 text-sm">
            <span className="hidden text-offwhite/80 sm:inline" title={me.email}>
              {me.name || me.email}
            </span>
            <button type="button" onClick={() => setLang(lang === "ar" ? "en" : "ar")} lang={lang === "ar" ? "en" : "ar"} className="min-h-11 rounded-lg px-3 font-bold text-amber hover:bg-offwhite/10">
              {lang === "ar" ? "English" : "العربية"}
            </button>
            <button type="button" onClick={signOut} className="min-h-11 rounded-lg px-3 text-offwhite/80 hover:bg-offwhite/10 hover:text-offwhite">
              {L("Sign out", "خروج")}
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-10" dir={pathname === "/" ? dir : "ltr"} lang={pathname === "/" ? lang : "en"}>
        <Outlet />
      </main>
    </div>
  );
}
